import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-test"]

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { BaseSwal } from '@/plugins/baseSwal';
import { onClickOutside } from '@vueuse/core';
import { useDialogStore } from '@/stores/useDialogStore';
import IconClose from '@/components/icons/IconClose.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModalDialog',
  props: {
  closeOnBackdrop: { type: Boolean, default: true },
  widthClass: { type: String, default: 'w-[95%] xl:w-8/12' },
  minWidthClass: { type: String, default: '' },
  maxWidthClass: { type: String, default: '' },
  heightClass: { type: String, default: '' },
  maxHeightClass: { type: String, default: '' },
  modalKey: { type: String, required: true },
  isFullHeight: { type: Boolean, default: false },
  hideClose: { type: Boolean, default: false },
},
  emits: ['on-close'],
  setup(__props, { emit }) {

const props = __props;





const store = useDialogStore();
const { showDialog } = storeToRefs(store);
const modalRef = ref(null);

function closeDialog() {
  emit('on-close');
  store.setShowDialog(props.modalKey, false);
}

onClickOutside(modalRef, () => {
  const showCurrentDialog = showDialog.value[props.modalKey];
  if (!BaseSwal.isVisible() && showCurrentDialog && props.closeOnBackdrop) {
    closeDialog();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration 100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          "data-test": `base-dialog-${__props.modalKey}`,
          class: "fixed top-0 left-0 w-full h-full bg-black/40 backdrop-blur overflow-y-auto z-50"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([
            'relative flex flex-col items-center w-full h-full min-h-full justify-center py-20 z-40',
            __props.isFullHeight ? 'h-full min-h-[700px]' : 'h-auto'
          ])
          }, [
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-200 transfrom",
              "enter-from-class": "opacity-0 translate-y-10",
              "enter-to-class": "opacity-100 translate-y-0",
              "leave-active-class": "transition ease-in duration-100 transfrom",
              "leave-from-class": "opacity-100 translate-y-0",
              "leave-to-class": "opacity-0 translate-y-10"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", {
                  ref_key: "modalRef",
                  ref: modalRef,
                  class: _normalizeClass([
                'relative flex flex-col h-full p-9 bg-white shadow-lg',
                __props.widthClass,
                __props.minWidthClass,
                __props.maxWidthClass,
                __props.heightClass,
                __props.maxHeightClass
              ]),
                  role: "dialog"
                }, [
                  (!__props.hideClose)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "absolute top-5 right-9 group",
                        onClick: closeDialog
                      }, [
                        _createVNode(IconClose, { "class-stroke": 'group-hover:stroke-zbr-primary' })
                      ]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default")
                ], 2), [
                  [_vShow, _unref(showDialog)[__props.modalKey]]
                ])
              ]),
              _: 3
            })
          ], 2)
        ], 8, _hoisted_1), [
          [_vShow, _unref(showDialog)[__props.modalKey]]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})